import { redirect } from '@tanstack/react-router'
import type { SupportedLanguage } from '@/shared/i18n/supported-languages'
import type { HideablePublicPage } from '@/shared/seo/hidden-public-pages'
import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
} from '@/shared/i18n/supported-languages'
import { isPublicPageHidden } from '@/shared/seo/hidden-public-pages'

/**
 * When public sign-up is hidden, an account is created only on the way to an
 * invite or to a paid GTM checkout (`/gtm/purchase|start/:checkoutId`); the
 * destination passes through the normal verification flow.
 */
export function isSignupOpen(redirectTo?: string | null): boolean {
  return (
    !isPublicPageHidden('signup') ||
    Boolean(
      redirectTo && /\/(org-invites|gtm\/(purchase|start))\//.test(redirectTo),
    )
  )
}

/** Route `beforeLoad` guard: a hidden page redirects to the start page. */
export function redirectIfPublicPageHidden(
  page: HideablePublicPage,
  lang?: unknown,
): void {
  if (!isPublicPageHidden(page)) return
  const target: SupportedLanguage = isSupportedLanguage(lang)
    ? lang
    : DEFAULT_LANGUAGE
  throw redirect({ to: '/$lang', params: { lang: target }, replace: true })
}
